module.exports = require("@swa-ui/itinerary/src/FlightStopsTracker/FlightStopsTracker.module.scss");